import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addCommas,
    addFromColumn,
    sortCurrency,
    sortNumber,
    toCurrency,
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {convertStartAndEndDatesForFile} from '../shared/printFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/action/receipt';

/**
 * Class for displaying Product Units Purchased Summary in a table
 *
 */
class ProductUnitsPurchasedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Product Type', key: 'product_type_name'},
                {label: 'Category', key: 'product_category_name'},
                {label: 'Product Name', key: 'product_name'},
                {label: 'UPC', key: 'product_unit_id'},
                {label: 'Brand', key: 'product_brand'},
                {label: 'Unit Type', key: 'product_unit_type'},
                {label: 'Qty Sold', key: 'qty_sold'},
                {label: 'Qty Returned', key: 'qty_returned'},
                {label: 'Subtotal $ Sold', key: 'subtotal_sold'},
                {label: 'Subtotal $ Returned', key: 'subtotal_returned'},
                {label: 'Tax $ Sold', key: 'tax_sold'},
                {label: 'Tax $ Returned', key: 'tax_returned'},
                {label: 'Total $ Sold', key: 'total_sold'},
                {label: 'Total $ Returned', key: 'total_returned'},
                {label: 'Net Total', key: 'net_total'}
            ],
        };
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: nextProps.listData,
                summaryTableData: nextProps.listData
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /**
     * Set data for use by table
     *
     * @param listData
     */
    processData(listData) {
        this.setState({
            summaryList: listData,
            summaryTableData: listData
        });
    }

    /**
     * Update selected table data based on sort or filter
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange = (event, table) => {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    };

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    render() {

        const {
            endDate,
            startDate,
            system,
            tableFilename,
            tableKey,
            tableLabel
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartAndEndDatesForFile(startDate, endDate);
        const defaultSort = setDefaultTableSort('product_unit_id');

        // Headers and columns for ReactTable
        const tableColumns = [
            {
                Header: 'Product Information',
                columns: [
                    {
                        Header: () => (<span>Product<br/>Type</span>),
                        accessor: 'product_type_name',
                    },
                    {
                        Header: 'Category',
                        accessor: 'product_category_name',
                        width: 100
                    },
                    {
                        Header: () => (<span>Product<br/>Name</span>),
                        accessor: 'product_name',
                    },
                    {
                        Header: 'UPC',
                        accessor: 'product_unit_id',
                        width: 130
                    },
                    {
                        Header: 'Brand',
                        accessor: 'product_brand'
                    },
                    {
                        Header: 'Unit Type',
                        accessor: 'product_unit_type',
                    }
                ]
            },
            {
                Header: 'Transactions',
                columns: [
                    {
                        Header: () => (<span>Qty<br/>Sold</span>),
                        accessor: 'qty_sold',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'qty_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Qty<br/>Returned</span>),
                        accessor: 'qty_returned',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(summaryTableData, 'qty_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Subtotal<br/>$ Sold</span>),
                        accessor: 'subtotal_sold',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'subtotal_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Subtotal<br/>$ Returned</span>),
                        accessor: 'subtotal_returned',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'subtotal_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Tax<br/>$ Sold</span>),
                        accessor: 'tax_sold',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'tax_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Tax<br/>$ Returned</span>),
                        accessor: 'tax_returned',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'tax_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total<br/>$ Sold</span>),
                        accessor: 'total_sold',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Total<br/>$ Returned</span>),
                        accessor: 'total_returned',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'total_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: () => (<span>Net<br/>Total</span>),
                        accessor: 'net_total',
                        sortMethod: (a, b) => sortCurrency(a, b),
                        filterable: false,
                        style: tableStyles.right,
                        width: 125,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {toCurrency(addFromColumn(summaryTableData, 'net_total'))}
                            </span>
                        )
                    }
                ]
            }
        ];

        return (
            <div>
                <div className="reports-table-container">

                    {/* Table Header */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Button */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={`${tableFilename}-${system}-${dateString}.csv`}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export {tableLabel}
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>{tableLabel}</span>
                        </h3>
                    </div>

                    {/* Table: Display and Print */}
                    <ReactTable
                        key={`table-${tableFilename}-${tableKey}`}
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={5}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortOrFilterChange(e, this.productUnitsReactTable)}
                        onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.productUnitsReactTable)}
                        ref={(r) => this.productUnitsReactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped overflow no-print"
                    />
                    <ReactTable
                        key={`table-${tableFilename}-print-${tableKey}`}
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
            </div>
        )
    }
}

ProductUnitsPurchasedTable.propTypes = {
    addField: PropTypes.bool,
    endDate: PropTypes.string,
    listData: PropTypes.array,
    startDate: PropTypes.string,
    system: PropTypes.string,
    tableFilename: PropTypes.string,
    tableKey: PropTypes.string,
    tableLabel: PropTypes.string
};

ProductUnitsPurchasedTable.defaultProps = {
    addField: true,
    endDate: null,
    startDate: null,
    tableFilename: 'Product-Units',
    tableKey: 'Product-Units',
    tableLabel: 'Product Units Purchased'
};

export default ProductUnitsPurchasedTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitsPurchasedTable.js